import { WorldGrid } from '../world/WorldGrid';
import { Entity } from './Entity';

export class World {
  private grid: WorldGrid;
  private entities: Entity[];
  private nextEntityId: number;

  constructor(grid: WorldGrid) {
    this.grid = grid;
    this.entities = [];
    this.nextEntityId = 0;
  }

  getGrid(): WorldGrid {
    return this.grid;
  }

  getEntities(): Entity[] {
    return this.entities;
  }

  createEntity(): Entity {
    const entity = new Entity(this.nextEntityId++);
    this.entities.push(entity);
    return entity;
  }

  removeEntity(entity: Entity): void {
    const index = this.entities.indexOf(entity);
    if (index !== -1) {
      this.entities.splice(index, 1);
    }
  }

  // ... other methods
}